// extracted by mini-css-extract-plugin
export var copyableField = "_ph-4";
export var customerBadge = "_ph-0";
export var customerInfoTitle = "_ph-2";
export var details = "_ph-1";
export var dropdownContainer = "_ph-5";
export var dropdownImage = "_ph-6";
export var editAssigneeForm = "_ph-a";
export var editButton = "_ph-3";
export var email = "_ph-7";
export var hidden = "_ph-d";
export var input = "_ph-8";
export var saveButton = "_ph-b";
export var shopifyIcon = "_ph-c";
export var suggestionBadge = "_ph-e";
export var suggestionText = "_ph-f";
export var username = "_ph-9";